import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { motion } from 'framer-motion';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useTranslation } from 'react-i18next';

const AmcDashboardVisual = ({ infoPoint }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ 
            width: '100%', height: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column',
            backgroundColor: 'rgba(0,0,0,0.4)', borderRadius: 2, border: '1px solid rgba(255, 255, 255, 0.1)', p: 3,
            position: 'relative'
        }}>
            
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                <TrendingUpIcon sx={{ color: 'var(--secondary-color)', fontSize: 28 }} />
                <Typography sx={{ fontWeight: 800, color: 'white', letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '0.9rem' }}>
                    {t('industryApplicationsAmazon.interactive.amcDashboard.title')}
                </Typography>
            </Box>

            {/* Bar Chart Area */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2, flexGrow: 1, justifyContent: 'center' }}>
                
                {/* Bar 1: Authentic */}
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                        <Typography sx={{ fontSize: '0.8rem', color: '#cbd5e1', fontWeight: 600 }}>
                            {t('industryApplicationsAmazon.interactive.amcDashboard.aiAdsLabel')}
                        </Typography>
                        <Typography sx={{ fontSize: '0.8rem', color: 'white', fontWeight: 700 }}>
                            {t('industryApplicationsAmazon.interactive.amcDashboard.aiAdsRoas')}
                        </Typography>
                    </Box>
                    <Box sx={{ width: '100%', height: '12px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '6px', overflow: 'hidden' }}>
                        <motion.div 
                            initial={{ width: 0 }}
                            animate={{ width: '55%' }}
                            transition={{ duration: 1.5, ease: "easeOut", delay: 0.2 }}
                            style={{ height: '100%', backgroundColor: '#94a3b8', borderRadius: '6px' }}
                        />
                    </Box>
                </Box>

                {/* Bar 2: AI Generated */}
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                        <Typography sx={{ fontSize: '0.8rem', color: 'var(--secondary-color)', fontWeight: 600 }}>
                            {t('industryApplicationsAmazon.interactive.amcDashboard.authenticAdsLabel')}
                        </Typography>
                        <Typography sx={{ fontSize: '0.8rem', color: 'white', fontWeight: 700 }}>
                            {t('industryApplicationsAmazon.interactive.amcDashboard.authenticAdsRoas')}
                        </Typography>
                    </Box>
                    <Box sx={{ width: '100%', height: '12px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '6px', overflow: 'hidden' }}>
                        <motion.div 
                            initial={{ width: 0 }}
                            animate={{ width: '85%' }}
                            transition={{ duration: 1.5, ease: "easeOut", delay: 0.4 }}
                            style={{ height: '100%', backgroundColor: 'var(--secondary-color)', borderRadius: '6px' }}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Info Point Tooltip */}
            {infoPoint && (
                <Tooltip
                    placement={infoPoint.position || 'top'} 
                    arrow
                    disableFocusListener
                    disableTouchListener={false}
                    enterTouchDelay={0}
                    leaveTouchDelay={3000}
                    componentsProps={{
                        tooltip: { sx: { bgcolor: '#171F29', border: '1px solid var(--secondary-color)', boxShadow: '0 8px 32px rgba(0,0,0,0.9)', p: 1.5, maxWidth: 380 } },
                        arrow: { sx: { color: '#171F29' } }
                    }}
                    title={
                        <div style={{ textAlign: 'left', fontFamily: 'Roboto, sans-serif' }}>
                            <div style={{ fontWeight: 700, marginBottom: '10px', fontSize: '0.75rem', color: 'var(--secondary-color)', letterSpacing: '0.5px' }}>{infoPoint.title}</div>
                            <div style={{ color: '#cbd5e1', fontSize: '0.85rem', lineHeight: 1.5 }}>{infoPoint.reason}</div>
                        </div>
                    }
                >
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 1.8, type: 'spring' }}
                        style={{ 
                            position: 'absolute', bottom: '20px', right: '20px', width: '26px', height: '26px', 
                            backgroundColor: 'var(--secondary-color)', border: '2px solid white', borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'help', zIndex: 10,
                            boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
                        }}
                    >
                        <span style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', fontFamily: 'serif', marginTop: '-1px' }}>i</span>
                    </motion.div>
                </Tooltip>
            )}
        </Box>
    );
};

export default AmcDashboardVisual;